import {
  FulfilmentCentre,
  FulfilmentCentreRole,
} from '../redux-toolkits/fulfilment-centres/fulfilmentCentres.type'

export function getCurationContentCentres(centres?: FulfilmentCentre[]) {
  return centres?.some((centre) => centre.role === FulfilmentCentreRole.PARENT)
    ? []
    : centres
}
